<template>
    <div v-loading.fullscreen.lock="fullscreenLoading">

        <!--コンテンツ-->
        <main id="renew2_mypage">
            <div class="recommend_container">
                <div class="renew2_wrapper renew2_flex">
                    <div class="servicelist">
                        <ul class="servicelist__block renew2_pc">
                            <li class="servicelist__item waiting"><a href="/kr/resume/mypage"><img
                                        src="/kr/resume/static/renew2_img/icon_mypagetop.svg" alt="마이페이지"><br>마이페이지</a>
                            </li>
                            <li class="servicelist__item waiting"><a href="/kr/resume/mypage/yagioffer"><img
                                        src="/kr/resume/static/renew2_img/icon_yagioffer.svg" alt="야기오퍼"><br>야기오퍼</a>
                            </li>
                            <li class="servicelist__item waiting"><a href="/kr/resume/mypage/quickmail"><img
                                        src="/kr/resume/static/renew2_img/icon_quickmail.svg" alt="야기택배"><br>야기택배</a>
                            </li>
                            <li class="servicelist__item waiting"><a href="/kr/resume/mypage/quickemail"><img
                                        src="/kr/resume/static/renew2_img/icon_quickemail.svg" alt="야기메일"><br>야기메일</a>
                            </li>
                            <li class="servicelist__item onclick"><a href="/kr/resume/mypage/introduction"><img
                                        src="/kr/resume/static/renew2_img/icon_recommend.svg"
                                        alt="추천·소개서"><br>추천·소개서</a></li>
                        </ul>
                        <div class="renew2_sp">
                            <ul class="servicelist__block renew2_sp_flex">
                                <li class="servicelist__item waiting"><a href="/kr/resume/mypage/yagioffer"><img
                                            src="/kr/resume/static/renew2_img/icon_yagioffer.svg"
                                            alt="마이페이지"><br>마이페이지</a></li>
                                <li class="servicelist__item waiting"><a href="/kr/resume/mypage/quickmail"><img
                                            src="/kr/resume/static/renew2_img/icon_quickmail.svg"
                                            alt="야기택배"><br>야기택배</a></li>
                                <li class="servicelist__item waiting"><a href="/kr/resume/mypage/quickemail"><img
                                            src="/kr/resume/static/renew2_img/icon_quickemail.svg"
                                            alt="야기메일"><br>야기메일</a></li>
                                <li class="servicelist__item onclick"><a href="/kr/resume/mypage/introduction"><img
                                            src="/kr/resume/static/renew2_img/icon_recommend.svg"
                                            alt="추천·소개서"><br>추천·소개서</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="mypage_contents">
                        <div class="renew2_flex lead">
                            <h2>추천·소개서</h2>
                            <a href="https://special.yagish.jp/recommend/index.html" target="_blank" class="">추천/소개서에
                                대하여</a>
                        </div>
                        <p>당신의 매력을 더 알리기 위해 대학교수나 지인의 추천을 더할수 있습니다.</p>
                        <div class="recommend_block">
                            <p class="not_used">이용내역이 없습니다.</p>
                            <ul class="recommend_block__list">


                                <li v-for="(item, index) in introData.intro_info" :key="index"
                                    class="renew2_flex recommend_block__item">
                                    <p class="date">{{ item.regist_date }}</p><!--日付-->
                                    <p class="request"><span class="name">{{ item.intro_name }}</span>（<span
                                            class="mail">{{ item.intro_email }}</span>）</p>

                                    <div v-if="item.intro_text" class="btn_block">
                                        <div class="renew2_flex renew2_sp_flex">
                                            <button type="button" @click="sendThank(item.intro_detail_id);"
                                                class="el-button thanks el-button--default"><!----><!----><span>감사를
                                                    보내다</span>
                                            </button>
                                        </div>
                                        <div v-if="item.display_flag == 'N'">
                                            <p class="nodisplay_txt">열람을 다시 표시하고 싶다면</p>
                                            <button type="button" class="el-button display nodisplay el-button--default"
                                                @click="updDisplayFlag(item.intro_detail_id, 'Y');"><!----><!----><span>表示にする</span></button>
                                        </div>
                                        <div v-else>
                                            <p class="nodisplay_txt">열람을 중지하고 싶다면</p>
                                            <button type="button" class="el-button display nodisplay el-button--default"
                                                @click="updDisplayFlag(item.intro_detail_id, 'N');"><!----><!----><span>非表示にする</span></button>
                                        </div>
                                    </div>
                                    <p v-else class="untreated">미작성</p>


                                </li>

                            </ul>
                        </div>
                        <div class="content-wrapper" style="width:100%;">
                            <a :href="recomm_code" class="reco-confirm">추천 및 소개글을 정리하여 확인</a>
                        </div>
                        <div class="renew2_sp">
                            <a href="/kr/resume/mypage" class="servicelist__mypage"><img
                                    src="/kr/resume/static/renew2_img/icon_mypagetop.svg" alt="마이페이지">마이페이지로</a>
                        </div>
                    </div>
                </div>
            </div>

            <!--SP-->
            <!--<div class="top_container renew2_sp">
                <div class="renew2_wrapper">
                    <h2>마이페이지</h2>



                    <div class="servicelist">
                        <h3>각종 서비스 이용 현황</h3>
                        <ul class="renew2_sp_flex servicelist__block">
                            <li><a href=""><img src="/kr/resume/static/renew2_img/icon_yagioffer.svg" alt="야기오퍼"><br>야기오퍼</a></li>
                            <li><a href=""><img src="/kr/resume/static/renew2_img/icon_quickmail.svg" alt="야기택배"><br>야기택배</a></li>
                            <li><a href=""><img src="/kr/resume/static/renew2_img/icon_quickemail.svg" alt="야기메일"><br>야기메일</a></li>
                            <li><a href=""><img src="/kr/resume/static/renew2_img/icon_recommend.svg" alt="추천·소개서"><br>추천·소개서</a></li>
                        </ul>
                    </div>
                </div>
            </div>-->
        </main>


    </div>
</template>

<style lang="css" src="@/assets/css/renew2_mypage.css"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
</style>

<style scoped></style>



<script>
import {
    TabPane,
    Tabs,
    MessageBox
} from 'element-ui'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
import LetterPreview from '@/components/formats/LetterPreview'
import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
    components: {
        'rirekisho-preview': RirekishoPreview,
        'shokurekisho-preview': ShokurekishoPreview,
        'letter-preview': LetterPreview,
        'el-tabs': Tabs,
        'el-tab-pane': TabPane,
        'login-forms': LoginForms,
        Slick
    },
    data: function () {
        return {
            fullscreenLoading: true,
            recentEdit: {
                FormatId: ''
            },
            introData: {},
            backupList: {
                auto: [],
                user: []
            },
            dialogVisible: false,
            selectedYagiOfferData: {},
            selectedQuickEmailData: {},
            yagiOfferData: [],
            quickemailList: [],
            qmail_rirekisho_html: '',
            qmail_shokumukeirekisho_html: '',
            backupListLoaded: {
                auto: false,
                user: false
            },
            slickOptions: {
                accessibility: true,
                autoplay: true,
                autoplaySpeed: 2400,
                speed: 400
            },
            saved: false,
            recomm_code: '',
            saveLabel: '',
            backupDataToConfirm: null,
            previewScale: 1,
            previewQEmailScale: 1,
            backupDataViewerCssRirekisho: {},
            backupDataViewerCssShokurekisho: {},
            qmailViewerCssRirekisho: {},
            qmailViewerCssShokurekisho: {},
            deleteBackupPopoverVisible: false,
            previewLoading: false,
            rirekisho_height: 110,
            keirekisho_height: 110,
            previewQEmailLoading: false,
            activeTabName: 'user',
            activePreviewTab: 'format_rirekisho',
            activeQEmailPreviewTab: 'format_rirekisho'
        }
    },
    computed: {
        formattedBackupData: function () {
            if (!this.backupDataToConfirm) return {}
            const content = JSON.parse(this.backupDataToConfirm.value.content)
            console.error(content)
            return {
                lastSaveDate: this.backupDataToConfirm.value.lastSaveDate,
                label: this.backupDataToConfirm.value.label,
                format_rirekisho: content.format_rirekisho || {},
                format_shokumukeirekisho: content.format_shokumukeirekisho || {},
                format_letter: content.format_letter || {},
                basicData: content.basicData || {},
                platform: this.backupDataToConfirm.value.platform
            }
        },
        getMode: function () {
            return process.env.VUE_APP_MODE
        },
        scaleQEmailStyle: function () {
            const _style = {
                'transform': 'scale(' + this.previewQEmailScale + ')',
                'transform-origin': 'top left',
                'height': (this.rirekisho_height * this.previewQEmailScale)
            }
            return _style
        }
    },
    methods: {
        setPreviewScale: function () {
            this.$nextTick(function () {
                if (this.$refs.backupDataViewer.$el.clientWidth === 0) {
                } else {
                    const clientWidth = this.$refs.backupDataViewer.$el.clientWidth
                    this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
                    // console.log(clientWidth, this.previewScale)
                }
                this.$nextTick(function () {
                    this.setPreviewHeight()
                })
            })
        },
        setQEmailPreviewScale: function () {
            this.$nextTick(function () {

                if (this.activeQEmailPreviewTab === 'format_rirekisho') {
                    if (this.$refs.rirekisho_pane.clientWidth === 0) {
                    } else {
                        const clientWidth = this.$refs.rirekisho_pane.clientWidth
                        this.previewQEmailScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
                    }
                } else if (this.activeQEmailPreviewTab === 'format_shokumukeirekisho') {
                    if (this.$refs.shokumukeirekisho_pane.clientWidth === 0) {
                    } else {
                        const clientWidth = this.$refs.shokumukeirekisho_pane.clientWidth
                        this.previewQEmailScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
                    }
                }
                this.$nextTick(function () {
                    this.setQEmailPreviewHeight()
                })
            })
        },
        sendThank: function (intro_detail_id) {
            const app = this
            const formData = new FormData()
            console.error(intro_detail_id)
            formData.append('intro_detail_id', intro_detail_id)
            formData.append('uuid', app.$firebase.user.uid)
            formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
            formData.append('version', '2')
            formData.append('reqflg', '2')

            this.$axios
                .post(this.$varuna.endPoints.sendIntroductionThank, formData, { timeout: 60000 })
                .then(function (response) {
                    app.$message({
                        duration: 0,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `메일전송성공`,
                        type: 'success'
                    })
                })
                .catch(function (error) {
                    app.$message({
                        duration: 0,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `멩리전송실패`,
                        type: 'error'
                    })

                }).finally(function () {

                })
        },
        updDisplayFlag: function (intro_detail_id, displayFlag) {
            const app = this
            const formData = new FormData()
            console.error(intro_detail_id)
            formData.append('intro_detail_id', intro_detail_id)
            formData.append('uuid', app.$firebase.user.uid)
            formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
            formData.append('display_flag', displayFlag)
            formData.append('version', '2')
            formData.append('reqflg', '2')

            this.$axios
                .post(this.$varuna.endPoints.updateIntroductionDisplay, formData, { timeout: 60000 })
                .then(function (response) {
                    app.$message({
                        duration: 0,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `성공하였습니다`,
                        type: 'success'
                    })
                    app.$axios
                        .post(app.$varuna.endPoints.getIntroduction, formData, { timeout: 60000 })
                        .then(function (response) {
                            app.introData = response.data
                        })
                        .catch(function (error) {
                        }).finally(function () {

                        })
                })
                .catch(function (error) {
                    app.$message({
                        duration: 0,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `실패하였습니다`,
                        type: 'error'
                    })

                }).finally(function () {

                })
        },
        setPreviewHeight: function () {
            const height = this.$refs.backupDataViewer.$refs.previewMain.getBoundingClientRect().height
            // const height = 10
            if (!height) {
                return
            }
            if (this.activePreviewTab === 'format_rirekisho' && height > 0) {
                this.backupDataViewerCssRirekisho = {
                    height: height + 30 + 'px'
                }
            } else if (this.activePreviewTab === 'format_shokumukeirekisho' && height > 0) {
                this.backupDataViewerCssShokurekisho = {
                    height: height + 30 + 'px'
                }
            }
        },
        setQEmailPreviewHeight: function () {
            const height = this.$refs.rirekisho_pane.getBoundingClientRect().height
            // const height = 10
            if (!height) {
                return
            }

            if (this.activeQEmailPreviewTab === 'format_rirekisho' && height > 0) {
                this.qmailViewerCssRirekisho = {
                    height: height + 30 + 'px'
                }
                this.rirekisho_height = height + 30
            } else if (this.activeQEmailPreviewTab === 'format_shokumukeirekisho' && height > 0) {
                this.qmailViewerCssShokurekisho = {
                    height: height + 30 + 'px'
                }
                this.keirekisho_height = height + 30
            }
        },
        openDialog: function () {
            this.$modal.show('confirm-backup-dialog')
            this.backupDataViewerCssRirekisho = {}
            this.backupDataViewerCssShokurekisho = {}
        },
        closeDialog: function () {
            this.$modal.hide('confirm-backup-dialog')
            this.deleteBackupPopoverVisible = false
        },
        confirmBackup: function (backup) {
            // console.log(backup)
            this.backupDataToConfirm = backup
            this.previewLoading = true
            this.openDialog()
        },
        openQuickemailCancelModal: function () {
            this.$modal.hide('qemail-detail-dialog')

            this.$modal.show('qemail-cancel-confirm-dialog')
        },
        cancelQuickemail: function () {
            const app = this
            const formData = new FormData()
            formData.append('history_id', this.selectedQuickEmailData.history_id)
            formData.append('uuid', app.$firebase.user.uid)

            this.$axios
                .post(this.$varuna.endPoints.cancelQuickemail, formData, { timeout: 60000 })
                .then(function (response) {
                    app.$message({
                        message: '전송을 취소하였습니다',
                        type: 'info'
                    })
                    app.selectedQuickEmailData.cancel_flag = '1'
                    app.$modal.hide('qemail-cancel-confirm-dialog')
                })
                .catch(function (error) { })
                .finally(function () { })
        },
        setDefaultSaveLabel: function () {
            if (this.$yagi.profile.name) {
                this.saveLabel = this.$yagi.profile.name + '의 백업'
            } else {
                this.saveLabel = '백업'
            }
        },
        saveBackup: function () {
            if (this.$yagi.profile.name) {
                this.saveLabel = this.$yagi.profile.name + '의 백업'
            } else {
                this.saveLabel = '백업'
            }
            this.$firebase.addBackup(this.saveLabel, 'user')
            this.loadBackupList('user')
            this.saved = true
        },
        loadBackupList: function (type) {
            const app = this
            app.backupListLoaded[type] = false
            app.backupList[type] = []
            app.$firebase.getBackupList('all', 5)
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        app.backupList[type].push({
                            id: doc.id,
                            value: doc.data()
                        })
                    })
                    app.backupListLoaded[type] = true
                })
                .catch(function (err) {
                    console.error(err)
                })
        },
        loadBackup: function (backup) {
            this.$firebase.loadBackup(backup.id)
            this.closeDialog()
        },
        deleteBackup: function (backup) {
            this.$firebase.deleteBackupWithMessage(backup.id, backup.value.label)
            console.log('deleteBackup', backup)
            this.getBackups(true)
            this.closeDialog()
        },
        openYagiOfferDetailDialog: function (idx) {
            this.$modal.show('offer-detail-dialog')
            this.selectedYagiOfferData = this.yagiOfferData.offer_list[idx]
            console.error(this.selectedYagiOfferData)
            if (this.selectedYagiOfferData.read_flag != '1') {
                const app = this
                const formData = new FormData()
                formData.append('offer_id', this.selectedYagiOfferData.offer_id)
                formData.append('uuid', app.$firebase.user.uid)

                this.$axios
                    .post(this.$varuna.endPoints.readYagiOffer, formData, { timeout: 60000 })
                    .then(function (response) { })
                    .catch(function (error) { })
                    .finally(function () { })
            }
        },
        openQuickEmailDetailDialog: function (idx) {
            this.$modal.show('qemail-detail-dialog')
            this.selectedQuickEmailData = this.quickemailList.qemail_list[idx]
            console.error(this.selectedQuickEmailData)
            this.qmail_rirekisho_html = this.selectedQuickEmailData.rirekisho_html
            this.qmail_shokumukeirekisho_html = this.selectedQuickEmailData.keirekisho_html
            this.qmailViewerCssRirekisho = {}
            this.qmailViewerCssShokurekisho = {}
        },
        dataChanged: function () {
            this.saved = false
            this.setDefaultSaveLabel()
        },
        submitOffer: function () {
            const app = this
            const formData = new FormData()
            formData.append('offer_id', this.selectedYagiOfferData.offer_id)
            formData.append('uuid', app.$firebase.user.uid)

            this.$axios
                .post(this.$varuna.endPoints.submitYagiOffer, formData, { timeout: 60000 })
                .then(function (response) {
                    for (let _item of app.yagiOfferData.offer_list) {
                        if (app.selectedYagiOfferData.offer_id == _item.offer_id) {
                            _item.offer_status = 'accept'
                        }
                    }
                    app.$message({
                        duration: 3000,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `오퍼를 수락했습니다`,
                        type: 'success'
                    })
                })
                .catch(function (error) {
                    app.$message({
                        duration: 3000,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `오퍼 수락 처리를 실패했습니다.`,
                        type: 'error'
                    })
                }).finally(function () {

                })
            console.error(this.selectedYagiOfferData.offer_id)
        },
        denyOffer: function () {
            const app = this
            const formData = new FormData()
            formData.append('offer_id', this.selectedYagiOfferData.offer_id)
            formData.append('uuid', app.$firebase.user.uid)

            this.$axios
                .post(this.$varuna.endPoints.denyYagiOffer, formData, { timeout: 60000 })
                .then(function (response) {
                    for (let _item of app.yagiOfferData.offer_list) {
                        if (app.selectedYagiOfferData.offer_id == _item.offer_id) {
                            _item.offer_status = 'refuse'
                        }
                    }
                    app.$message({
                        duration: 3000,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `오퍼를 거절하였습니다`,
                        type: 'success'
                    })
                })
                .catch(function (error) {
                    app.$message({
                        duration: 3000,
                        showClose: true,
                        dangerouslyUseHTMLString: true,
                        message: `오퍼의 거절 처리를 실패했습니다.`,
                        type: 'error'
                    })
                }).finally(function () {

                })
            console.error(this.selectedYagiOfferData.offer_id)
        },
        loadRecentEdit: function () {
            const app = this
            this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
                if (err) {
                    console.log(err)
                }
                if (data) {
                    app.recentEdit = data
                }
            })
        },
        getBackups: function (force) {
            if (this.$deviceLib.isOnline && this.$firebase.isAuthenticated) {
                if (force) {
                    this.loadBackupList('auto')
                    this.loadBackupList('user')
                } else {
                    if (!this.backupListLoaded['user']) {
                        this.loadBackupList('user')
                    }
                    if (!this.backupListLoaded['auto']) {
                        this.loadBackupList('auto')
                    }
                }
            }
        }
    },
    created: function () {
        const app = this
        // console.log(this.$route.query.mynavi)
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                console.log('logined')
                const formData = new FormData()
                formData.append('access_id', '')
                formData.append('uuid', app.$firebase.user.uid)
                formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
                formData.append('version', '2')
                formData.append('reqflg', '2')

                this.$axios
                    .post(this.$varuna.endPoints.getIntroduction, formData, { timeout: 60000 })
                    .then(function (response) {
                        app.introData = response.data
                        app.recomm_code = "/recomm_preview/" + response.data.access_id
                    })
                this.fullscreenLoading = false

            } else {
                this.$router.push('/login')
            }
        })
        this.loadRecentEdit()
    },
    beforeMount: function () {
        this.$eventHub.$on('basic-data-changed', this.dataChanged)
        this.$eventHub.$on('format-data-changed', this.dataChanged)
        this.$eventHub.$on('firebase-initialized', this.getBackups)
        this.$eventHub.$on('yagi-profile-loaded', this.setDefaultSaveLabel)
        this.$eventHub.$on('yagi-profile-saved', this.setDefaultSaveLabel)
        this.setDefaultSaveLabel()
        this.getBackups()
    },
    destroyed: function () {
        this.$eventHub.$off('basic-data-changed', this.dataChanged)
        this.$eventHub.$off('format-data-changed', this.dataChanged)
        this.$eventHub.$off('firebase-initialized', this.getBackups)
        this.$eventHub.$off('yagi-profile-loaded', this.setDefaultSaveLabel)
        this.$eventHub.$off('yagi-profile-saved', this.setDefaultSaveLabel)
    }
}
</script>
